import AdminTemplatesGate from "#/admin/templates/components/AdminTemplatesGate";
import MessageTemplatesLayout from "#/message-templates/components/MessageTemplatesLayout";

export default function AdminMessageTemplatesPage() {
  return (
    <AdminTemplatesGate>
      <MessageTemplatesLayout />
    </AdminTemplatesGate>
  );
}
